import { render, staticRenderFns } from "./SignatureTextCase.vue?vue&type=template&id=746ca5ac&"
import script from "./SignatureTextCase.vue?vue&type=script&lang=js&"
export * from "./SignatureTextCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports